module.exports = __webpack_public_path__ + "static/media/salesforce.76f6200d.jpg";